import type { NotificationType } from '../services/notifications/types';

export const queryKeys = {
  auth: {
    me: ['auth', 'me'] as const,
  },
  customers: {
    me: ['customers', 'me'] as const,
    accessible: ['customers', 'accessible'] as const,
    meSubscription: ['customers', 'me', 'subscription'] as const,
  },
  indicators: {
    chartMetadata: ['indicators', 'dashboard-chart-metadata'] as const,
    ethanol: {
      filterOptions: ['indicators', 'ethanol', 'filter-options'] as const,
      maxDate: ['indicators', 'ethanol', 'max-date'] as const,
      dailyVariation: (params: { quantity: number; baseDate: string; ethanolType: string }) =>
        ['indicators', 'ethanol', 'daily-variation', params] as const,
    },
    derivatives: {
      filterOptions: ['indicators', 'derivatives', 'filter-options'] as const,
      maxDate: ['indicators', 'derivatives', 'max-date'] as const,
      pbVariationPpi: (params: {
        quantity: number;
        baseDate: string;
        productLinesId: string;
        refineriesId?: string;
      }) => ['indicators', 'derivatives', 'pb-variation-ppi', params] as const,
    },
    biodiesel: {
      maxDate: ['indicators', 'biodiesel', 'max-date'] as const,
      catalog: ['indicators', 'biodiesel', 'catalog'] as const,
      pricesOverview: (params: { baseDate: string; quantity: number }) =>
        ['indicators', 'biodiesel', 'prices-overview-and-variation', params] as const,
    },
    quotes: {
      maxDate: ['indicators', 'quotes', 'max-date'] as const,
      weeklyFuelVariation: (params: {
        quantity: number;
        baseDate: string;
        calculationType: 'min' | 'average';
      }) => ['indicators', 'quotes', 'weekly-fuel-variation', params] as const,
    },
    marketPanel: {
      dashboard: ['indicators', 'market-panel', 'panel-dashboard'] as const,
    },
  },
  notifications: {
    unreadCount: (type?: NotificationType) =>
      ['notifications', 'count-unread', type ?? 'all'] as const,
    list: (params: Record<string, unknown>) => ['notifications', 'list', params] as const,
  },
  admin: {
    pendingSummaries: ['admin', 'shell', 'pending-summaries'] as const,
    pendingProposals: ['admin', 'market-indicator-proposals', 'pending-summary'] as const,
    pendingMyStationFlags: (weekId?: string) =>
      ['admin', 'my-station-flags', 'pending-summary', weekId ?? 'all'] as const,
  },
  payments: {
    billingStatus: ['payments', 'billing-status'] as const,
  },
  consultant: {
    dashboard: ['consultant', 'dashboard'] as const,
    regionSummary: (regionId: string) => ['consultant', 'region-summary', regionId] as const,
    distributorQuotes: ['consultant', 'distributor-quotes'] as const,
    distributors: ['consultant', 'distributors'] as const,
  },
  dashboard: {
    acquisitionCostSeries: (params: {
      fuelType: string;
      periodFrom?: string;
      periodTo?: string;
      limit?: number;
    }) => ['dashboard', 'acquisition-cost-series', params] as const,
  },
} as const;
